import '.cm{font-size:1.125rem;}.ssr-plugin'
import '.f7{line-height:1.75rem;}.ssr-plugin'
import '.az{text-decoration:none;}.ssr-plugin'
import '.d4{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="cm f7"
    >
      {translations.privacySubtitle}{' '}
      <a className="az d4"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="az d4"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
